import { CheckIcon } from "@chakra-ui/icons";
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  CloseButton,
} from "@chakra-ui/react";

export const MessageSuccess = (message: {
  title: string;
  description: string;
}) => (
  <>
    <Alert status="success" variant="solid">
      <CheckIcon mr={2} />
      <Box flex="1">
        <AlertTitle>{message.title}</AlertTitle>
        <AlertDescription display="block">
          {message.description}
        </AlertDescription>
      </Box>
    </Alert>
  </>
);
